module.exports = __webpack_public_path__ + "img/badge.5ec0a93a.png";